import { clsx } from 'clsx';
import {
  Typography,
  TypographyProps,
} from '@design-system/components/typography/typography';
import { mdToHTML } from './mdToHTML';

type Props = Omit<TypographyProps, 'children' | 'dangerouslySetInnerHTML'> & {
  content: string;
};

// Renders markdown-style text as sanitized rich content: markdown links,
// bare-URL autolinks, and emoji shortcodes. Links are blue (blue-2 on hover),
// set here because the global anchor style is purple and must be overridden.
// `whitespace-pre-wrap` is required, not cosmetic: mdToHTML preserves source
// newlines and emits no block markup, so the container must honor them.
export const MarkdownContent = ({ content, className, ...props }: Props) => (
  <Typography
    className={clsx(
      'whitespace-pre-wrap text-[#131313] [&_a]:text-blue-1 [&_a:hover]:text-blue-2',
      className,
    )}
    dangerouslySetInnerHTML={{ __html: mdToHTML(content) }}
    {...props}
  />
);
